import { ReactNode } from 'react';
import { toast } from 'react-toastify';

const success = (message: string | ReactNode) => {
  toast.success(message, {
    className: '--toastify-color-success',
  });
};

export default success;
